import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputNameSF from '../../../widgets/form/InputNameSF'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const UserCreateModalUI = ({context, successMsg, errorList, setErrorList,
    // email
    email, onEmailChange, emailError, setEmailError,
    // name
    firstName, lastName, onFirstNameChange, onLastNameChange, firstNameError, lastNameError, setFirstNameError, setLastNameError,
    // superuser role
    superuserRoleId, superuserRoleList, onSuperuserRoleIdChange, superuserRoleIdError,
    // modes
    createMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Add super user'
    buttonLabel='Add'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='email' label='Email' required={true} maxLength={64}
      value={email} onChange={onEmailChange}
      error={emailError} setError={setEmailError}
      autoFocus={true}
    />
    {
      context.session.appCode !== 'finapp' &&
      <InputNameSF type='name' name='name' label='Name' required={true}
        firstName={firstName} lastName={lastName}
        firstNameError={firstNameError} lastNameError={lastNameError}
        onFirstNameChange={onFirstNameChange} onLastNameChange={onLastNameChange}
        setFirstNameError={setFirstNameError} setLastNameError={setLastNameError}
      />
    }
    <InputSelectUI name='superuserRoleId' label='Role' value={superuserRoleId} required={true}
      optionList={superuserRoleList}
      onChange={onSuperuserRoleIdChange} error={superuserRoleIdError}
    />
  </ModalFormUI>

export default UserCreateModalUI
